import { render, staticRenderFns } from "./view-chat.vue?vue&type=template&id=5a68fa30&scoped=true&"
import script from "./view-chat.vue?vue&type=script&lang=js&"
export * from "./view-chat.vue?vue&type=script&lang=js&"
import style0 from "./view-chat.vue?vue&type=style&index=0&id=5a68fa30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68fa30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a68fa30')) {
      api.createRecord('5a68fa30', component.options)
    } else {
      api.reload('5a68fa30', component.options)
    }
    module.hot.accept("./view-chat.vue?vue&type=template&id=5a68fa30&scoped=true&", function () {
      api.rerender('5a68fa30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/views/chat/view-chat.vue"
export default component.exports